import { motion } from "framer-motion";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: AiFillGithub,
      url: "https://github.com/Benedict-Kpaduwa",
      label: "GitHub",
    },
    {
      icon: AiOutlineTwitter,
      url: "https://twitter.com/Benedict___K",
      label: "Twitter",
    },
    {
      icon: FaLinkedinIn,
      url: "https://www.linkedin.com/in/benedictkpaduwa/",
      label: "LinkedIn",
    },
    {
      icon: AiFillInstagram,
      url: "https://www.instagram.com/benedict__k/",
      label: "Instagram",
    },
  ];

  return (
    <footer className="relative bg-dark-light border-t border-purple-900/20 py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center text-center md:text-left">
          {/* Designer Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-sm md:text-base text-gray-300"
          >
            <p>Designed and Developed by</p>
            <p className="text-purple-400 font-semibold">Benedict Kpaduwa</p>
          </motion.div>

          {/* Copyright */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-sm md:text-base text-gray-300"
          >
            <p>Copyright © {currentYear} BK</p>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex justify-center md:justify-end gap-4"
          >
            {socialLinks.map((social, index) => (
              <motion.a
                key={social.label}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
                className="text-white hover:text-purple-400 transition-colors duration-300 text-xl"
                aria-label={social.label}
              >
                <social.icon />
              </motion.a>
            ))}
          </motion.div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
